/* eslint camelcase: 0 */
import moment from 'moment-timezone'
import { toBeacontypeProps } from './beacontype'
import { toAreaProps } from './area'
import { Beacon, BeaconSeed } from '@/infrastructure/network/Legacy/schema'
import { IBeaconProps, EmptyBeaconPropsFactory } from '@/entities/Legacy/Beacon'
import { EmptyBeacontypePropsFactory } from '@/entities/Legacy/Beacontype'

export const toBeaconProps = (props: Beacon): IBeaconProps => {
  if (!props) {
    return EmptyBeaconPropsFactory()
  }

  const {
    id,
    beacontype,
    beacontype_id,
    area,
    major,
    minor,
    zeacon,
    battery,
    tag_number_enabled,
    partners_enabled,
    body_temperature_enabled,
    health_check_enabled,
    measuring_thermometer_enabled,
    send_battery,
    sending_at,
    exhausting_at,
    created_at,
    battery_at,
    order
  } = props

  return {
    id,
    beacontype: beacontype ? toBeacontypeProps(beacontype) : EmptyBeacontypePropsFactory(),
    area: toAreaProps(area),
    beacontypeId: beacontype_id,
    name: area ? area.name : '',
    major,
    minor,
    zeacon,
    battery: battery || -1,
    tagNumberEnabled: tag_number_enabled,
    partnersEnabled: partners_enabled,
    bodyTemperatureEnabled: body_temperature_enabled,
    healthCheckEnabled: health_check_enabled,
    measuringThermometerEnabled: measuring_thermometer_enabled,
    isBattery: !!send_battery,
    isFixed: area ? !!area.is_fixed : false,
    isNoApprovalReq: area ? !!area.is_no_approval_req : false,
    sendingAt: sending_at ? moment(sending_at).utc().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss') : '',
    exhaustingAt: exhausting_at ? moment(exhausting_at).utc().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss') : '',
    batteryAt: battery_at ? moment(battery_at).utc().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss') : '',
    createdAt: created_at ? moment(created_at).utc().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss') : '',
    order
  }
}

export const toBeaconSeed = (props: IBeaconProps): BeaconSeed => {
  const {
    id,
    beacontypeId,
    name,
    major,
    minor,
    tagNumberEnabled,
    partnersEnabled,
    bodyTemperatureEnabled,
    healthCheckEnabled,
    measuringThermometerEnabled,
    zeacon,
    isFixed,
    sendingAt,
    exhaustingAt,
    order
  } = props

  return {
    id,
    beacontype_id: beacontypeId || '',
    name,
    major: major || 0,
    minor: minor || 0,
    tag_number_enabled: tagNumberEnabled,
    partners_enabled: partnersEnabled,
    body_temperature_enabled: bodyTemperatureEnabled,
    health_check_enabled: healthCheckEnabled,
    measuring_thermometer_enabled: measuringThermometerEnabled,
    is_fixed: isFixed,
    zeacon,
    sending_at: sendingAt ? moment(sendingAt).tz('Asia/Tokyo').utc().format('YYYY-MM-DD HH:mm:ss') : '',
    exhausting_at: exhaustingAt ? moment(exhaustingAt).tz('Asia/Tokyo').utc().format('YYYY-MM-DD HH:mm:ss') : '',
    order
  }
}
